import { useEffect, useRef, useState } from "react";
import SmartPlanFilterData from "../../pages/Smartplans/components/SmartPlanFilterData";
import { initialSmartPlanFilterData } from "../../utils/initialData";
import { countNonMatchingEntries, handleDropdownClose } from "../../utils/utils";
import RightModal from "../Modal/RightModal";
import SavedFilterComponent from "../SavedFilters/SavedFilterComponent";

const SmartPlanFilter = ({ filterData, onSetFilterData, onCallApiAgain }) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
    const id = localStorage.getItem("selectedSavefilterId");
    return id ? id : "";
  });

  const count = countNonMatchingEntries(filterData, initialSmartPlanFilterData);

  useEffect(() => {
    const handleClose = () => {
      setIsSidebarOpen(false);
    };
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  const handleFilter = () => {
    localStorage.setItem("filterData", JSON.stringify(filterData));
    onCallApiAgain();
    setIsSidebarOpen(false);
    setSelectedSaveFilterId("");
  };

  const handleSelectFilter = (value) => {
    const dataToSet = {
      duration: value?.duration ?? "",
      touches: value?.touches ?? "",
      task_type: value?.task_type ?? "",
      repeat_number: value?.repeat_number ?? "",
      link_other_smartplan: value?.link_other_smartplan ?? [],
      sales_associate: value?.sales_associate ?? [],
      priority: value?.priority ?? [],
      contacts: value?.contacts ?? [],
    };
    localStorage.setItem("filterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    onCallApiAgain(dataToSet);
  };

  const saveSearchFilterData = {
    duration: filterData?.duration,
    touches: filterData?.touches,
    task_type: filterData?.task_type,
    repeat_number: filterData?.repeat_number,
    sales_associate: filterData?.sales_associate,
    link_other_smartplan: filterData?.link_other_smartplan ?? [],
    priority: filterData?.priority,
    contacts: filterData?.contacts,
  };

  return (
    <div>
      <SavedFilterComponent
        from="smartplan"
        count={count}
        isSidebarOpen={isSidebarOpen}
        saveSearchFilterData={saveSearchFilterData}
        selectedSavefilterId={selectedSavefilterId}
        initialFilterData={initialSmartPlanFilterData}
        onCallApiAgain={onCallApiAgain}
        onSetFilterData={onSetFilterData}
        onSetSelectedSaveFilterId={(value) => {
          setSelectedSaveFilterId(value);
        }}
        handleSelectFilter={handleSelectFilter}
        onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
      />

      <RightModal
        isOpen={isSidebarOpen}
        onClose={() => {
          setIsSidebarOpen(false);
          // onSetFilterData(initialSmartPlanFilterData);
        }}
        ref={dropdownRef}
        title={"Filter"}
        desc={"Enter Touchplan information."}
        onFilter={handleFilter}
        from="smartplan"
        saveSearchFilterData={saveSearchFilterData}
        onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
      >
        <SmartPlanFilterData isSidebarOpen={isSidebarOpen} filterData={filterData} onSetFilterData={onSetFilterData} />
      </RightModal>
    </div>
  );
};

export default SmartPlanFilter;
